import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { SecondaryButton, DefaultButton } from '@/components/ui/Button';
import { AlertTriangle } from 'lucide-react';

interface ConfirmDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName?: string;
  childCount?: number;
}

export default function ConfirmDeleteModal({ open, onClose, onConfirm, itemName, childCount = 0 }: Readonly<ConfirmDeleteModalProps>) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="bg-white rounded-lg p-6 max-w-md w-full">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0">
              <AlertTriangle className="text-red-500" size={24} />
            </div>
            <div className="flex-1">
              <DialogTitle className="text-lg font-semibold text-gray-900">Confirm Deletion</DialogTitle>
              <div className="mt-2 text-sm text-gray-600 space-y-2">
                <p>
                  Are you certain you want to delete{itemName ? ` "${itemName}"` : ' this item'}? This action cannot be undone.
                </p>
                {childCount > 0 && (
                  <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                    <p className="font-semibold text-yellow-800">
                      ⚠️ Warning: This item has {childCount} child {childCount === 1 ? 'node' : 'nodes'}
                    </p>
                    <p className="text-yellow-700 mt-1">
                      All child nodes will be permanently deleted along with this item.
                    </p>
                  </div>
                )}
              </div>
              <div className="mt-5 flex justify-end gap-2">
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                <DefaultButton
                  onClick={onConfirm}
                  className="!bg-red-500 hover:!bg-red-600 text-white rounded-lg px-4 py-2 text-sm font-medium"
                >
                  Delete {childCount > 0 ? `(${childCount + 1} total)` : ''}
                </DefaultButton>
              </div>
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
